module.exports = __webpack_public_path__ + "static/009-025bb15d2f0716b1c438d49bfa1ec3a9.jpg";